<template>
  <div style="display: inline-block">
    <el-input v-if="pickType==0" type="input" :placeholder="puPlaceholder" v-model="FinalVal" suffix-icon="el-icon-search" @click.native='()=>{showDialog=true;queryData()}'></el-input>
    <el-button type="primary" v-if="pickType==1" @click='startPick'>{{$slots.default[0].text}}</el-button>
    <el-dialog append-to-body :title="title" :visible="showDialog" @close="showDialog = false" width="500px" class="dialog">
      <div class="table">
        <!--=========查询模块================-->
        <div class="container">
          <div class="handle-box">
            <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="100px">
              <el-row>
                <el-col :span="8">
                  <el-button type="primary" @click="pickUp">Confirm</el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <!--=========查询模块END================-->
          <!--=========用户信息数据列表================-->
          <el-table :data="tableData" ref="pickUserTable" row-key="tmUserId" border highlight-current-row @selection-change="selectionChange">
            <el-table-column v-if="puMulti" :reserve-selection="true" prop="tmUserId" type="selection" min-width="55" align="center" />
            <el-table-column v-if="!puMulti" prop="name" :label="$t('common.select')" align="center" min-width="55">
              <template slot-scope="scope">
                <el-radio v-model="selectDataAll" :label="scope.row">{{scope.row.name}}</el-radio>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="name" label="User Name"></el-table-column>
          </el-table>
        </div>
        <!--=========用户信息数据列表END================-->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { userService } from "@/api/user-manage/user";
import { Message } from "element-ui";
import commonFun from "@/utils/commonFun";
import { apiService } from "@/api/material/material-master-data";

export default {
  name: 'pickupCategoryLeader',
  props: {
    pickType: {
      type: Number,
      default: 0
    },
    value: Object,
    title: String,
    multi: Boolean,
    placeholder: String,
    queryConditions: Object
  },
  data() {
    return {
      puMulti: this.multi,
      puPlaceholder: this.placeholder,
      tableData: [],
      selectedId: this.value,
      selectDataAll: this.multi ? {
        defaultData: commonFun.convertToArray(this.value),
        pageDatas: []
      } : null,
      totalCount: 0,
      labelPosition: 'right',
      queryCondition: { 
        pageSize: 15, 
        pageNum: 1, 
        name: '', 
        userCd: '' 
      },
      showDialog: false,
      notSelRoles: [],
      selRoles: [],
      userId: null,
      userInfo: {},
      showUserInfo: false,
      FinalVal: '',
    }
  },
  mounted() {
    Object.assign(this.queryCondition, this.queryConditions);
  },
  computed: {
    getSelectedData() {
      this.updateCheck();
      if (this.multi) {
        let selectedData = [];
        let defaultData = this.selectDataAll.defaultData;
        if (commonFun.isNotEmpty(defaultData)) {
          selectedData.push(...defaultData);
        }
        let pageDatas = this.selectDataAll.pageDatas;
        for (let pageData of pageDatas.values()) {
          if (commonFun.isNotEmpty(pageData)) {
            selectedData.push(...pageData);
          }
        }
        let tmpArr = [];
        selectedData.forEach(user => {
          if (tmpArr.filter(tmp => tmp.tmUserId == user.tmUserId).length == 0) {
            tmpArr.push(user);
          }
        })
        return tmpArr;
      } else {
        return this.selectDataAll;
      }
    },
    transferTo() {
      if (commonFun.isEmpty(this.getSelectedData)) {
        return null;
      }
      if (this.puMulti) {
        return this.getSelectedData.map(user => user.name).join(";");
      } else {
        return this.selectDataAll.name;
      }
    }
  },
  watch: {
    value(newVal) {
      if (newVal == null) {
        this.selectDataAll = null;
      }
      this.selectDataAll.defaultData = commonFun.convertToArray(newVal);
    }
  },
  methods: {
    startPick() {
      this.showDialog = true;
      this.queryData();
      this.$refs.pickUserTable.clearSelection();
    },
    init() {
      this.selectDataAll = this.multi ? {
        defaultData: commonFun.convertToArray(this.value),
        pageDatas: []
      } : null;
      this.$refs.pickUserTable.clearSelection();
    },
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      var that = this;
      apiService.categoryLeaderList({ type: "CQS" }).then((res) => {
        let tableData = res.data;
        tableData = tableData.map(leader => {
          return {
            tmUserId: leader.tmUserId,
            name: leader.userName
          }
        })
        this.tableData = tableData;
      }).then(value => {
        this.$nextTick(() => {
          that.updateCheck();
        })
      });
    },
    pickUp() {
      if (this.puMulti) {
        this.$emit('input', this.getSelectedData);
        this.FinalVal = this.getSelectedData.map(value => value.name);
      } else {
        this.$emit('input', this.getSelectedData);
        this.FinalVal = this.getSelectedData.name;
      }
      this.$emit('change', this.getSelectedData);
      this.$emit('pickUp', this.getSelectedData);


      this.showDialog = false;
    },
    selectionChange(users) {
      let that = this;
      let pageNum = that.queryCondition.pageNum;
      this.$set(that.selectDataAll.pageDatas, pageNum, Array.isArray(users) ? users : [users]);
    },
    //页码变化
    pageNumberChange(val) {
      this.queryCondition.pageNum = val;
      this.queryData();
    },
    //显示条数变更
    pageSizeChange(val) {
      this.queryCondition.pageSize = val;
      this.queryData();
    },
    //查询条件重置方法
    restQueryForm: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition.pageSize = 15;
      this.queryCondition.pageNum = 1;
    },
    editUserInfo(row) {
      this.userInfo = {};
      this.clearVlidate("userInfoForm");
      this.userInfo = row;
      this.showUserInfo = true;
    },
    updateCheck() {
      if (!this.puMulti) {
        if (!commonFun.isEmpty(this.selectDataAll)) {
          this.tableData.forEach(row => {
            if ((row.tmUserId == this.selectDataAll.tmUserId)) {
              this.selectedId = row.tmUserId;
              this.selectDataAll = row;
            }
          });
        }
      } else {
        var that = this;
        let defaultData = this.selectDataAll.defaultData;
        let existsArr = [];
        defaultData.forEach((data, i) => {
          if (commonFun.isNotEmpty(data)) {
            that.tableData.forEach(row => {
              if (row.tmUserId == data.tmUserId) {
                that.$refs["pickUserTable"].toggleRowSelection(row, true);
                existsArr.push(i);
              }
            });
          }
        });
        existsArr.forEach(i => {
          this.selectDataAll.defaultData.splice(i, 1);
        });
      }
    }
  }
}
</script>
<style scoped>
.handle-input {
  width: 95%;
}

.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}

/*穿梭框样式重写*/
.el-transfer .el-transfer-panel {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  display: inline-block;
  vertical-align: middle;
  width: 255px;
  max-height: 100%;
  box-sizing: border-box;
  position: relative;
}

.el-transfer-panel__body {
  height: 370px;
}

.el-transfer-panel__list.is-filterable {
  height: 360px;
}
</style>
